import emailjs from "@emailjs/browser";
const state = {
  sendingEmail: false,
  emailSent: false,
  emailError: null,
};

const getters = {
  StateSendingEmail: (state) => state.sendingEmail,
  StateEmailSent: (state) => state.emailSent,
  StateEmailError: (state) => state.emailError,
};

const mutations = {
  setSendingEmail(state, value) {
    state.sendingEmail = value;
  },
  setEmailSent(state, value) {
    state.emailSent = value;
  },
  setEmailError(state, error) {
    state.emailError = error;
  },
};

const actions = {
  SendContactEmail({ commit }, data) {
    const userId = "0dm5TAN3pnNwRJ45-";
    const serviceId = "service_ycla78";
    const templateId = "template_ycla868478";

    commit("setSendingEmail", true);
    commit("setEmailSent", false);
    commit("setEmailError", null);

    emailjs
      .sendForm(serviceId, templateId, data, userId)
      .then(() => {
        commit("setSendingEmail", false);
        commit("setEmailSent", true);
        commit("setEmailError", null);
      })
      .catch((error) => {
        commit("setSendingEmail", false);
        commit("setEmailSent", false);
        commit("setEmailError", error);
      });
  },

  SendCallMeMail({ commit }, data) {
    const userId = "0dm5TAN3pnNwRJ45-";
    const serviceId = "service_ycla78";
    const templateId = "template_ycla868478";

    commit("setSendingEmail", true);
    commit("setEmailSent", false);
    commit("setEmailError", null);

    emailjs
      .sendForm(serviceId, templateId, data, userId)
      .then(() => {
        commit("setSendingEmail", false);
        commit("setEmailSent", true);
        commit("setEmailError", null);
      })
      .catch((error) => {
        commit("setSendingEmail", false);
        commit("setEmailSent", false);
        commit("setEmailError", error);
      });
  },
  SendBookingMail({ commit }, data) {
    const userId = "0dm5TAN3pnNwRJ45-";
    const serviceId = "service_ycla78";
    const templateId = "template_ycla868478";

    commit("setSendingEmail", true);
    commit("setEmailSent", false);
    commit("setEmailError", null);

    emailjs
      .sendForm(serviceId, templateId, data, userId)
      .then(() => {
        commit("setSendingEmail", false);
        commit("setEmailSent", true);
        commit("setEmailError", null);
      })
      .catch((error) => {
        commit("setSendingEmail", false);
        commit("setEmailSent", false);
        commit("setEmailError", error);
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
